import React from "react";
import MediaTypeDisplay from "./MediaTypeDisplayComponent";
import { MediaAttachment, RootState } from "src/shared/types/src";

type iProps = { 
    media: MediaAttachment[] 
}
const SingleAttachment: React.FC<iProps> = ({ media }) => {

    return (
        <div className="media-collage-1">
            <div className="media-collage-item">
                <MediaTypeDisplay media={media[0]} collageDisplay={true} largePlayIcon={true}/>
            </div>
        </div>
    )
}

export default SingleAttachment;